// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   WorkMockExample — 아티팩트 패널 타입 미리보기 (공개 /work-mock-example)
   .gf-showcase-page 래퍼로 --gf-* 토큰을 받아 운영 패널과 동일하게 렌더.
   ============================================================ */

/* .prompt(앱 셸 다크 배경)보다 specificity 우위를 둬 라이트 배경을 강제.
   안 그러면 .prompt { background: var(--fg-bg-dark) } 가 이겨 페이지가 어두워지고
   섹션 타이틀(--gf-ink, 다크 네이비)이 배경에 묻힌다. 기본 글자색도 다크로 고정. */
.prompt.wme {
  min-height: 100vh;
  background: #eef1f4;
  color: var(--gf-ink, #0e1b2b);
  padding-bottom: 80px;
}

/* 상단 바 */
.wme__bar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--gf-navy, #13314f);
  color: #fff;
}
.wme__bar-inner {
  max-width: 1080px;
  margin: 0 auto;
  padding: 18px 24px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
}
.wme__title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #fff;
}
.wme__sub {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.72);
}
.wme__bar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: none;
}
.wme__count {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.92);
  background: rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  padding: 5px 12px;
}
.wme__close {
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: transparent;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  padding: 7px 14px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.wme__close:hover { background: rgba(255, 255, 255, 0.14); }

/* 섹션(에이전트별) 컨테이너 */
.wme__sections {
  max-width: 1320px;
  margin: 0 auto;
  padding: 12px 24px 0;
}
.wme__section {
  padding-top: 30px;
}
.wme__section-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
  padding-bottom: 10px;
  margin-bottom: 24px;
  border-bottom: 2px solid var(--gf-navy, #13314f);
}
.wme__section-badge {
  flex: none;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border-radius: 999px;
  padding: 3px 10px;
  align-self: center;
}
.wme__section-badge--agent {
  color: #fff;
  background: var(--gf-navy, #13314f);
}
.wme__section-badge--common {
  color: var(--gf-navy, #13314f);
  background: #eef2f6;
  border: 1px solid var(--gf-line, rgba(14, 27, 43, 0.16));
}
.wme__section-title {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: var(--gf-ink, #0e1b2b);
}
.wme__section-desc {
  margin: 0;
  font-size: 12.5px;
  color: #5c6b7a;
}
.wme__section-count {
  margin-left: auto;
  flex: none;
  font-size: 12px;
  font-weight: 600;
  color: #5c6b7a;
}

/* 카드 그리드 */
.wme__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(600px, 1fr));
  gap: 28px;
  align-items: start;
}
.wme__card {
  background: #fff;
  border: 1px solid var(--gf-line, rgba(14, 27, 43, 0.12));
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 30px -22px rgba(14, 27, 43, 0.4);
}
.wme__card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--gf-line, rgba(14, 27, 43, 0.1));
  background: #f7f9fb;
}
.wme__card-type {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
  background: var(--gf-navy, #13314f);
  border-radius: 5px;
  padding: 3px 8px;
}
.wme__card-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--gf-ink, #0e1b2b);
}
.wme__card-variant {
  font-size: 11px;
  font-weight: 600;
  color: var(--gf-navy-soft, #3c5a78);
  background: #eef2f6;
  border-radius: 999px;
  padding: 2px 9px;
}
.wme__card-body {
  /* gf-work__panel-body 패딩을 그대로 쓰되, 아주 긴 아티팩트만 스크롤 */
  max-height: 760px;
  overflow: auto;
}

@media (max-width: 1024px) {
  .wme__sections { max-width: 760px; }
  .wme__grid { grid-template-columns: 1fr; }
}
@media (max-width: 560px) {
  .wme__sections { padding: 4px 16px 0; }
  .wme__bar-inner { flex-direction: column; align-items: flex-start; }
}
`, "",{"version":3,"sources":["webpack://./src/css/WorkMockExample.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;;uDAEuD;AACvD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA,oBAAoB,qCAAqC,EAAE;;AAE3D,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,wDAAwD;AAC1D;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;AACrB;AACA;EACE,qEAAqE;EACrE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB,gBAAgB,EAAE;EACnC,aAAa,0BAA0B,EAAE;AAC3C;AACA;EACE,iBAAiB,mBAAmB,EAAE;EACtC,kBAAkB,sBAAsB,EAAE,uBAAuB,EAAE;AACrE","sourcesContent":["/* ============================================================\n   WorkMockExample — 아티팩트 패널 타입 미리보기 (공개 /work-mock-example)\n   .gf-showcase-page 래퍼로 --gf-* 토큰을 받아 운영 패널과 동일하게 렌더.\n   ============================================================ */\n\n/* .prompt(앱 셸 다크 배경)보다 specificity 우위를 둬 라이트 배경을 강제.\n   안 그러면 .prompt { background: var(--fg-bg-dark) } 가 이겨 페이지가 어두워지고\n   섹션 타이틀(--gf-ink, 다크 네이비)이 배경에 묻힌다. 기본 글자색도 다크로 고정. */\n.prompt.wme {\n  min-height: 100vh;\n  background: #eef1f4;\n  color: var(--gf-ink, #0e1b2b);\n  padding-bottom: 80px;\n}\n\n/* 상단 바 */\n.wme__bar {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: var(--gf-navy, #13314f);\n  color: #fff;\n}\n.wme__bar-inner {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 18px 24px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px;\n}\n.wme__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: #fff;\n}\n.wme__sub {\n  margin: 6px 0 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.72);\n}\n.wme__bar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: none;\n}\n.wme__count {\n  font-size: 13px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.92);\n  background: rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  padding: 5px 12px;\n}\n.wme__close {\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  background: transparent;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 7px 14px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.wme__close:hover { background: rgba(255, 255, 255, 0.14); }\n\n/* 섹션(에이전트별) 컨테이너 */\n.wme__sections {\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 12px 24px 0;\n}\n.wme__section {\n  padding-top: 30px;\n}\n.wme__section-head {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding-bottom: 10px;\n  margin-bottom: 24px;\n  border-bottom: 2px solid var(--gf-navy, #13314f);\n}\n.wme__section-badge {\n  flex: none;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  border-radius: 999px;\n  padding: 3px 10px;\n  align-self: center;\n}\n.wme__section-badge--agent {\n  color: #fff;\n  background: var(--gf-navy, #13314f);\n}\n.wme__section-badge--common {\n  color: var(--gf-navy, #13314f);\n  background: #eef2f6;\n  border: 1px solid var(--gf-line, rgba(14, 27, 43, 0.16));\n}\n.wme__section-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: var(--gf-ink, #0e1b2b);\n}\n.wme__section-desc {\n  margin: 0;\n  font-size: 12.5px;\n  color: #5c6b7a;\n}\n.wme__section-count {\n  margin-left: auto;\n  flex: none;\n  font-size: 12px;\n  font-weight: 600;\n  color: #5c6b7a;\n}\n\n/* 카드 그리드 */\n.wme__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(600px, 1fr));\n  gap: 28px;\n  align-items: start;\n}\n.wme__card {\n  background: #fff;\n  border: 1px solid var(--gf-line, rgba(14, 27, 43, 0.12));\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px -22px rgba(14, 27, 43, 0.4);\n}\n.wme__card-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--gf-line, rgba(14, 27, 43, 0.1));\n  background: #f7f9fb;\n}\n.wme__card-type {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", monospace;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #fff;\n  background: var(--gf-navy, #13314f);\n  border-radius: 5px;\n  padding: 3px 8px;\n}\n.wme__card-label {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--gf-ink, #0e1b2b);\n}\n.wme__card-variant {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--gf-navy-soft, #3c5a78);\n  background: #eef2f6;\n  border-radius: 999px;\n  padding: 2px 9px;\n}\n.wme__card-body {\n  /* gf-work__panel-body 패딩을 그대로 쓰되, 아주 긴 아티팩트만 스크롤 */\n  max-height: 760px;\n  overflow: auto;\n}\n\n@media (max-width: 1024px) {\n  .wme__sections { max-width: 760px; }\n  .wme__grid { grid-template-columns: 1fr; }\n}\n@media (max-width: 560px) {\n  .wme__sections { padding: 4px 16px 0; }\n  .wme__bar-inner { flex-direction: column; align-items: flex-start; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
